import { Box, Grid } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { AssetDetail } from 'views/SensorAnalysisView/SensorAnalysisView/Header/AssetDetail';
import { type Asset } from 'types/asset.types';
import { AssetSelector } from '../VehicleStatus/AssetSelector';
import { useAppSelector } from 'store/hook';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const Header = ({
  enableDarkTheme,
  selectedAsset,
  latestTagData,
  hierarchyInfo,
  makeModels,
  assetBumperIds,
  setSelectedAsset,
  selectedMakeModel,
  setSelectedMakeModel,
}: {
  enableDarkTheme: boolean;
  selectedAsset: Asset;
  latestTagData: any;
  hierarchyInfo: any;
  makeModels: string[];
  assetBumperIds: string[];
  setSelectedAsset: any;
  selectedMakeModel: string;
  setSelectedMakeModel: any;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { assets } = useAppSelector((state) => state.assetReducer);

  return (
    <Grid container>
      <Grid item sm={12} md={6} lg={6}>
        <Box
          sx={{
            borderRadius: '5px',
            marginTop: '17px',
            backgroundColor: enableDarkTheme
              ? palette.boxBackground
              : palette.boxBackground,
            color: palette.textPrimary,
            paddingBottom: '5px',
            display: 'flex',
            minHeight: '100px',
          }}
        >
          <AssetSelector
            makeModels={makeModels}
            enableDarkTheme={enableDarkTheme}
            selectedMakeModel={selectedMakeModel}
            setSelectedMakeModel={setSelectedMakeModel}
            assetBumperIds={assetBumperIds}
            selectedAsset={selectedAsset}
            setSelectedAsset={setSelectedAsset}
            inputWidth="130px"
            latestTagData={latestTagData}
          />
        </Box>
      </Grid>
      <Grid item sm={12} md={12} lg={6}>
        <AssetDetail
          enableDarkTheme={enableDarkTheme}
          selectedAsset={selectedAsset}
          latestTagData={latestTagData}
          hierarchyInfo={hierarchyInfo}
          assets={assets}
        />
      </Grid>
    </Grid>
  );
};

export default Header;
